/*
 * Handles the counter for the number of selected items
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListCounter/sortableListCounterView",
], function (Marionette, Backbone, Messenger, SortableListCounterView) {
  var SortableListCounterController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "sortableListCounter";
      this.region = options.region;
      this.namespace = options.namespace;
      this._setUpVents();
    },
    show: function () {
      var model = new Backbone.Model();
      model.set("checkedCount", 0);
      this.view = new SortableListCounterView.sortableListCounterView({ model: model });
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      var namespace;
      if (this.namespace) {
        namespace = this.namespace + ":";
      } else {
        namespace = "";
      }
      Messenger.vent.on(
        namespace + "changed:checkboxes",
        function () {
          if (this.view) {
            var checkedBoxes = Messenger.reqres.request(namespace + "checked:models");
            this.view.model.set("checkedCount", checkedBoxes.length);
          }
        },
        this,
      );
    },
  });

  return SortableListCounterController;
});
